import Colour from 'components/utils/Colour'
import React from 'react'

function LuxPlusMonthHeroTitleContent() {
  return <>LuxPlus<Colour value="highlight-lux-plus">+</Colour> Month</>
}

export default LuxPlusMonthHeroTitleContent
